<template>
  <div class="grid grid-cols-1 gap-3 sm:gap-4 sm:grid-cols-2 mb-4">
    <div>
      <p class="text-sm text-gray-900 dark:text-gray-100 font-medium">
        {{ getTableDisplay(order) }}
      </p>
    </div>
    <div>
      <h4 class="text-sm font-medium text-gray-500 dark:text-gray-400">
        {{ $t('app.views.orders.modals.details.order_time') }}
      </h4>
      <p class="mt-1 text-sm text-gray-900 dark:text-gray-100">
        {{ formatDateTime(order.createdAt) }}
      </p>
    </div>
    <div>
      <h4 class="text-sm font-medium text-gray-500 dark:text-gray-400">
        {{ $t('app.views.orders.modals.details.customer') }}
      </h4>
      <p class="mt-1 text-sm text-gray-900 dark:text-gray-100">
        {{ order.customer_name ||
          $t('app.views.orders.modals.details.no_name') }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { getOrderTableDisplay } from '@/utils/orderHelpers'

interface Props {
  order: {
    table?: any
    order_type?: string
    customer_name?: string
    createdAt?: string | Date
  }
}

const props = defineProps<Props>()
const { t } = useI18n()

const getTableDisplay = (order: any) => {
  return getOrderTableDisplay(order, t)
}

const formatDateTime = (dateString: string | Date | undefined) => {
  if (!dateString) return ''
  const date = new Date(dateString)
  return date.toLocaleString('es-ES')
}
</script>
